import Immutable from 'immutable';

import * as types from '../actions/actionTypes';

export const initialState = Immutable.List();

const agreementReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_AGREEMENTS_SUCCESS: {
      return Immutable.List(action.agreements);
    }
    default: {
      return state;
    }
  }
};

export default agreementReducer;



// WEBPACK FOOTER //
// ./src/reducers/agreementReducer.js